// nav list data
export const LogoImage =
  "https://cdn-icons-png.flaticon.com/512/147/147144.png";
export const NavList = [
  { routeName: "Home", routePath: "/" },
  { routeName: "Posts", routePath: "/posts" },
  { routeName: "WebStore", routePath: "/service/webstore" },
  { routeName: "AppStore", routePath: "/service/appstore" },
  { routeName: "Service", routePath: "/service" },
];
export const UserSectionList = [{ routeName: "Login", routePath: "/login" }];
export const workExp = [
  {
    Position: "Full Stack Developer",
    Image: "./assets/mernCard.png",
    Aos: "flip-up",
    desc: "Proficient Full-Stack Developer with 2+ years of experience (self project) using the MERN stack. Adept at developing and maintaining scalable, responsive web applications from front-end to back-end. Skilled in MongoDB, ExpressJS, ReactJS, and NodeJS. Proven track record of delivering high-quality projects on time and within budget.",
    link: "https://github.com/premprakashgupta/",
  },
  {
    Position: "PHP Developer",
    Image: "./assets/phpCard.png",
    Aos: "flip-down",
    desc: "As a PHP developer, I have extensive experience in developing and maintaining dynamic web applications using PHP and various related technologies. I have hands-on experience in building and integrating databases, designing and implementing user-friendly interfaces, and writing clean, optimized, and reusable code.",
    link: "https://github.com/premprakashgupta/",
  },
];
export const skillData = [
  {
    image: "./assets/figma.png",
    title: "Figma",
  },
  {
    image: "./assets/react.png",
    title: "React",
  },
  {
    image: "./assets/c.png",
    title: "C language",
  },
  {
    image: "./assets/nodejs.png",
    title: "NodeJs",
  },
  {
    image: "./assets/jsCard.png",
    title: "javascript",
  },
  {
    image: "./assets/css3Card.png",
    title: "CSS3",
  },
  {
    image: "./assets/mongodbCard.png",
    title: "MongoDb",
  },
];
export const projectData = [
  {
    name: "Netflix Clone",
    link: "https://studyflix.netlify.app/",
    desc: "The Netflix clone is a web project that replicates the frontend interface of the popular streaming platform, Netflix. It is a visually appealing website that allows users to browse and search for their favorite TV shows and movies. The project features a clean and user-friendly interface with a modern design, intuitive navigation, and a responsive layout.",
  },
  {
    name: "webEditor Clone",
    link: "https://webeditor4u.netlify.app/",
    desc: "Webeditor is a web-based application that functions as a virtual notepad. It allows users to create .txt and .pdf file online from any device with an internet connection. The user-friendly interface is designed to make note-taking quick and easy, with a clean, minimalist design and intuitive editing tools.",
  },
];
export const Avatar = "./assets/avatar.png";

export const ToastTimer = 5000;
